import { render, staticRenderFns } from "./CreateMyBranchBusinessAddress.vue?vue&type=template&id=61d75818&"
import script from "./CreateMyBranchBusinessAddress.vue?vue&type=script&lang=js&"
export * from "./CreateMyBranchBusinessAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports